export default class header {
    constructor() {
        this.mobileEventListner();
        this.mobileExpanderLister();
        this.desktopEventlistner();
    }

    mobileEventListner() {
        document.querySelectorAll('.site-mobile-header-toggle').forEach(link => {
            link.addEventListener('click', function(e) {
                e.currentTarget.classList.toggle('site-mobile-header-toggle--open');
                document.querySelector('.site-mobile-header-menu').classList.toggle('site-mobile-header-menu--open');
                document.body.classList.toggle('overflow-hidden');
            });
        });
    }

    mobileExpanderLister() {
        document.querySelectorAll('.site-mobile-header-menu-link__collapse').forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault();

                if (e.currentTarget.parentNode.classList.contains('site-mobile-header-menu-link__level1') && !e.currentTarget.parentNode.classList.contains('site-mobile-header-menu-link__level1--no-submenu')) {
                    if (e.currentTarget.parentNode.parentNode.classList.contains('active')) {
                        document.querySelectorAll('[class^=site-mobile-header-menu-link__level]').forEach(item => item.parentNode.classList.remove('active'));
                    } else {
                        document.querySelectorAll('[class^=site-mobile-header-menu-link__level]').forEach(item => item.parentNode.classList.remove('active'));
                        e.currentTarget.parentNode.parentNode.classList.add('active');
                    }
                }

                if (e.currentTarget.parentNode.classList.contains('site-mobile-header-menu-link__level2') && !e.currentTarget.parentNode.classList.contains('site-mobile-header-menu-link__level2--no-submenu')) {
                    if (e.currentTarget.parentNode.parentNode.classList.contains('active')) {
                        e.currentTarget.parentNode.parentNode.parentNode.querySelectorAll('li.active').forEach(item => item.classList.remove('active'));
                    } else {
                        e.currentTarget.parentNode.parentNode.parentNode.querySelectorAll('li.active').forEach(item => item.classList.remove('active'));
                        e.currentTarget.parentNode.parentNode.classList.add('active');
                    }
                }

            });
        });
    }

    desktopEventlistner() {
        document.querySelectorAll('.site-header-main-link').forEach(link => {
            link.addEventListener('click', e => {
                const _ = e.currentTarget;
                const submenu = _.parentNode.querySelector('.site-header-main-submenu');
                const currentLink = 'is-active';
                const currentSubmenu = 'is-active';

                if (_.dataset.link == 'true') {
                    document.querySelectorAll('.site-header-main-link').forEach(item => item.classList.remove(currentLink));
                    document.querySelectorAll('.site-header-main-submenu').forEach(item => item.classList.remove(currentSubmenu));

                    return;
                } else {
                    e.preventDefault();
                }

                if (submenu.classList.contains(currentSubmenu)) {
                    _.classList.remove(currentLink);
                    submenu.classList.remove(currentSubmenu);
                } else {
                    document.querySelectorAll('.site-header-main-link').forEach(item => item.classList.remove(currentLink));
                    document.querySelectorAll('.site-header-main-submenu').forEach(item => item.classList.remove(currentSubmenu));

                    _.classList.add(currentLink);
                    submenu.classList.add(currentSubmenu);

                    if (_.classList.contains('is-search')) {
                        _.parentNode.querySelector('input').focus();
                    }
                }
            });
        });
    }
}
